import { siteName } from "@/constants/config";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { FREE_REFERRAL_BONUS, PRO_REFERRAL_BONUS, REFEREE_BONUS } from "@/constants/config";

const PrivacySection = (props: {
  title: string;
  description: string;
  descriptions: [string];
  img: string;
}) => {
  const { title, description, descriptions, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      {descriptions &&
        descriptions.map((description, i) => {
          return (
            <Typography component={"p"} color={""}>
              {description}
            </Typography>
          );
        })}
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      // title: "1. What information do we collect?",
      description:
        'Welcome to the ' + siteName + ' Referral Program (hereinafter referred to as the "Program"). By participating in this Program, you agree to abide by the following terms and conditions.',
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      title: "1. Program Overview",
      description:
        "1.1. The " + siteName + " Referral Program is an ongoing promotion offered by " + siteName + " LLC. The Company reserves the right to modify, terminate, or amend the terms of this promotion at its sole discretion, with or without prior notice.",
      // img: "https://img.awardtool.com/guides/routes_1.png",
    },
    {
      title: "2. Eligibility",
      descriptions: [
        '2.1. To be eligible to participate as a referrer (hereinafter referred to as the "Referrer"), you must be an existing ' + siteName + ' customer or user.',
        '2.2. To be eligible to participate as a referee (hereinafter referred to as the "Referree"), you need to register as ' + siteName + ' customer or user with any Referrer\'s referral link.',
        "2.3. he Referred Friend must be a new user who has never had a " + siteName + " account in the past and can only redeem one referral offer when signing up.",
      ],
    },
    {
      title: "3. Referral Rewards",
      descriptions: [
        `3.1. PRO user enjoys more referral bonus. Each time a new user successfully and completely signs up using the PRO Referrer's unique referral link and become a PRO user, a credit of ${PRO_REFERRAL_BONUS} USD will be applied to the Referrer's awardtool account.`,
        // `3.1. Each time a new user successfully and completely signs up using the Referrer's unique referral link and become a free user, a credit of ${FREE_REFERRAL_BONUS} USD will be applied to the Referrer's awardtool account.`,
        `3.2. Each time a new user successfully and completely signs up using the Referrer's unique referral link and become a free user, a credit of ${REFEREE_BONUS} USD will be applied to the Referree's awardtool account, up to 12 USD.`,
        "3.3. The Company reserves the right to audit referrals for abuse. Referral credits deemed, in the sole determination of " + siteName + ", to be the result of abuse or fraud may be removed from the Referrer's account.",
        "3.4. If the Referrer's referral initiates a credit card dispute or uses a fraudulent payment method, the Company may remove the referral credit from the Referrer's account.",
      ],
    },
    {
      title: "4. Account Credits",
      descriptions: [
        "4.1. Account credits are automatically applied to future subscription payments to " + siteName + " before the Referrer's credit card is charged.",
        "4.2. Account credits are not redeemable for cash or any form of currency, and they can only be used for free " + siteName + " services.",
        "4.3. If the Referrer cancels their " + siteName + " account or if their subscription lapses, their credit balance will be forfeited.",
        "4.4. If the Referrer cancels their account or subscription, they will no longer be eligible for any future account credits, and their existing credit balance will be forfeited.",
      ],
    },
    {
      title: "5. Referral Link Usage",
      descriptions: [
        "5.1. If the Referred Friend does not use the Referrer's unique link when signing up, a credit will not be applied to the Referrer's account.",
        "5.2. The Company may apply a credit if the Referred Friend signs up within two weeks of clicking the Referrer's link. However, long-term conversion tracking is not guaranteed.",
        "5.3. The most recent referral link or campaign click will be used to identify the referrer eligible to earn the credit.",
      ],
    },
    {
      description:
        "By participating in the " + siteName + " Referral Program, you acknowledge that you have read, understood, and agreed to these Terms and Conditions. The Company reserves the right to interpret, modify, or enforce these Terms at its discretion.",
    },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
